import { createSelector } from '@reduxjs/toolkit';
import { Store } from 'components/common/types/Store.types';

export const getCampaignsWithOOCFrames = createSelector(
  (state: Store) => state.programmaticOOC.oocReport,
  (oocReport) => oocReport.campaigns,
);

export const getOOCFramesCount = createSelector(
  (state: Store) => state.programmaticOOC.oocReport,
  (oocReport) => oocReport.totalOocFrameCount,
);

export const getOOCCampaignsFramesCount = createSelector(
  (state: Store) => state.programmaticOOC.oocReport,
  (oocReport) => oocReport.campaigns.length,
);

export const getTotalOOCDealLineCount = createSelector(
  (state: Store) => state.programmaticOOC.oocReport,
  (oocReport) => oocReport.totalOocDealLineCount,
);

export const getOOCFrameCountByLineId = createSelector(
  (state: Store) => state.programmaticOOC.oocReport,
  (oocReport) =>
    oocReport.campaigns.reduce(
      (result, { oocDealLines }) => {
        oocDealLines.forEach(({ lineId, oocFrameCount }) => {
          result[lineId] = oocFrameCount;
        });
        return result;
      },
      {} as Record<string, number>,
    ),
);
